import {
  FileCategoryType,
  IFile,
  INumberedDocumentView,
  WorkflowStatusType,
} from '../../api-client/autogenerated';

/**
 * The files a document's Supporting Items card lists, before the card's own sort. Shared with the
 * CENTERLINE AI document review, which sends the same files to the reviewer.
 */

/** The statuses from which the Architect's returned file is part of the record. */
const ARCHITECT_FILE_VISIBLE_STATUSES: WorkflowStatusType[] = [
  WorkflowStatusType.Completed,
  WorkflowStatusType.ReviewComplete,
  WorkflowStatusType.Resolved,
  WorkflowStatusType.Resubmitted,
  WorkflowStatusType.Accepted,
];

/**
 * The document's files, its drawings-section file and its specification-section file (unless the
 * files already hold one), with the Architect's returned file left out until the review is done.
 */
export function collectDocumentFiles(document: INumberedDocumentView): IFile[] {
  const files = document.files?.slice() || [];
  if (document.drawingsSectionFile) files.push(document.drawingsSectionFile);
  if (
    document.submittalSectionFile &&
    !files.some((f) => f.category === FileCategoryType.SpecificationSection)
  )
    files.push(document.submittalSectionFile);
  if (
    document.workflowStatus &&
    !ARCHITECT_FILE_VISIBLE_STATUSES.includes(document.workflowStatus)
  ) {
    return files.filter((f) => f.category !== FileCategoryType.DocumentArchitectApproved);
  }
  return files;
}

/** Whether the Supporting Items card lists a file at all. */
export const isListedInSupportingItems = (file: IFile): boolean =>
  file.category !== FileCategoryType.DocumentBluebeamStudioLog && !file.isHiddenInSupportingItems;
